import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import dayjs from "dayjs";
import axios from "axios";

const API_KEY = "AIzaSyDDv9FFGFzMbPDsaPgRF8rIh5RP12uB98I";
const CALENDAR_ID = "1325b8c6067825f0531ccfe2635bb3d0fdd717e82fae00312289e78f06e5e7b0@group.calendar.google.com";

export default function MonthViewCalendar({ currentMonth, setCurrentDate }) {
    const [events, setEvents] = useState([]);

  useEffect(() => {
    fetchEvents();
  }, [currentMonth]);

  const fetchEvents = async () => {
    const timeMin = currentMonth.startOf("month").toISOString();
    const timeMax = currentMonth.endOf("month").toISOString();

    const url = `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(
      CALENDAR_ID
    )}/events?key=${API_KEY}&timeMin=${timeMin}&timeMax=${timeMax}&singleEvents=true&orderBy=startTime`;

    try {
      const response = await axios.get(url);
      setEvents(response.data.items);
    } catch (error) {
      console.error("Erreur lors du chargement des événements", error);
    }
  };

  const getEventsForDay = (date) => {
    return events.filter(
      (event) =>
        dayjs(event.start.dateTime || event.start.date).isSame(date, "day")
    );
  };

  const generateCalendar = () => {
    const startDay = currentMonth.startOf("month").day();
    const daysInMonth = currentMonth.daysInMonth();
    const daysInPrevMonth = currentMonth.subtract(1, "month").daysInMonth();

    const calendarDays = [];

    // Mois précédent
    for (let i = startDay - 1; i >= 0; i--) {
      calendarDays.push({
        date: currentMonth.subtract(1, "month").date(daysInPrevMonth - i),
        currentMonth: false,
      });
    }

    // Mois actuel
    for (let i = 1; i <= daysInMonth; i++) {
      calendarDays.push({
        date: currentMonth.date(i),
        currentMonth: true,
        today: currentMonth.date(i).isSame(dayjs(), "day"),
      });
    }

    // Mois suivant
    const nextDays = 42 - calendarDays.length;
    for (let i = 1; i <= nextDays; i++) {
      calendarDays.push({
        date: currentMonth.add(1, "month").date(i),
        currentMonth: false,
      });
    }

    return calendarDays;
  };

  return (
    <div className="max-w mx-auto bg-white shadow-xl rounded-lg p-6">
      <div className="grid grid-cols-7 text-center font-medium text-gray-700">
        {["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"].map((day) => (
          <div key={day} className="py-2">
            {day}
          </div>
        ))}
      </div>

      <AnimatePresence mode="wait">
        <motion.div
          key={currentMonth.format("MM-YYYY")}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
          className="grid grid-cols-7 gap-2 mt-2"
        >
          {generateCalendar().map(({ date, currentMonth, today }, idx) => {
            const dailyEvents = getEventsForDay(date);
            return (
              <div
                key={idx}
                className={`p-2 rounded-lg h-24 overflow-y-auto border ${
                  currentMonth ? "bg-gray-50" : "bg-gray-100 text-gray-400"
                } ${today ? "border-blue-500 bg-blue-50" : "border-transparent"}`}
              >
                <div className="text-sm font-semibold mb-1">{date.date()}</div>
                {dailyEvents.map((event, eventIdx) => (
                  <div
                    key={eventIdx}
                    className="text-xs bg-blue-200 text-blue-800 rounded px-1 py-0.5 my-0.5 truncate"
                  >
                    {event.summary}
                  </div>
                ))}
              </div>
            );
          })}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
